import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/ProductDetails';

export const PRODUCT_DETAILS_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const PRODUCT_DETAILS_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
